import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import CrowdSorcingUpdate from './crowd-sourcing-update';
import CrowdSourcingDetails from './crowd-sourcing-details';
import CrowdSourcing from './crowd-sourcing';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={CrowdSorcingUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={CrowdSorcingUpdate} />
     

      <ErrorBoundaryRoute exact path={`${match.url}/:id/details`} component={CrowdSourcingDetails} />
      <ErrorBoundaryRoute path={match.url} component={CrowdSourcing} />
    </Switch>
  </>
);

export default Routes;
